import { Translate } from 'react-localize-redux';
import { mainSiteLinks } from 'utils/consts/main-site-links';
import { ExternalLink } from '../style/RechargeInfoAlertModal.style';

export function FAQLink({
  label = 'lbl.faq.link.ricarica',
  fragment = '',
  isRicarica = true,
}: {
  label?: string;
  fragment?: string;
  isRicarica?: boolean;
}) {
  return (
    <ExternalLink
      target="_blank"
      rel="noopener"
      href={`${isRicarica ? mainSiteLinks.topUpsFaq : mainSiteLinks.withdrawalsFaqUrl}${fragment}`}
    >
      <Translate id={label} />
    </ExternalLink>
  );
}
